<template>
  <b-button type="is-primary" :loading="loadingButtonReportPdf" @click="generatePdf" icon-left="download">Descargar</b-button>
</template>
<script>
import html2canvas from 'html2canvas';
import moment from "moment";
import {eventBus} from '../../main';
export default {
  data() {
    return {
        loadingButtonReportPdf:false,
    };
  },
  methods: {
    generatePdf() {
        eventBus.$emit('adjustTable',true);
        // console.log(this.$parent.re);
      this.loadingButtonReportPdf = true;
      html2canvas(this.$parent.$refs.tablePatient,{
          width:1200,
          
      }).then((canvas) => {          
        var pdfMake = require("pdfmake/build/pdfmake.js");
        if (pdfMake.vfs == undefined) {
          var pdfFonts = require("pdfmake/build/vfs_fonts.js");
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        var docDefinition = {          
           pageSize: {
                width: 600,
                height: 1200
            },      
          content: [
            {
              text: `Reporte pacientes ${moment().format(
                "YYYY-MM-DD HH:mm"
              )}`,
              style: "header",
              bold: true,
              marginBottom: 15,
            },
            {
              image: canvas.toDataURL("image/png"),
              width: 500,
              // marginBottom: 20,
              // pageBreak: report.pageBreak
            },
          ],
          styles: {
            tableExample: {
              alignment: "justify",
              margin: [0, -150, 0, 15],
            },
            toTheRight: {
              alignment: "right",
            },
            header: {
              fontSize: 17,
              alignment: "left",
              bold: true,
            },
          },
        };
        pdfMake.createPdf(docDefinition)
          .download(
            `Reporte ${moment().format("YYYY-MM-DD HH:mm")}.pdf`,
            () => {
                eventBus.$emit('adjustTable',false);
                this.loadingButtonReportPdf = false;
            }
          );
      });
    },
  },
};
</script>